import { c as _c } from "react/compiler-runtime";
import PremiumAccessButton from '@/app/[locale]/(worlds)/[roomId]/components/PremiumAccessButton';
import CloseIcon from '@/components/assets/icon_close.svg';
import IconDiamond from '@/components/assets/icon_diamond.svg';
import WarningIcon from '@/components/assets/icon_warning.svg';
import { Button } from '@/components/ui/button';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
import { useIsClient } from 'usehooks-ts';
const RenderPremiumButton = () => {
  const $ = _c(6);
  const isClient = useIsClient();
  const {
    roomData,
    isVoucherCheckPassed
  } = useCheckEnterRoomContext();
  const {
    isMobileApp,
    isMobile
  } = useUAContext();
  let t0;
  if ($[0] !== isClient || $[1] !== isMobile || $[2] !== isMobileApp || $[3] !== isVoucherCheckPassed || $[4] !== roomData) {
    t0 = isClient && !isMobileApp && !isMobile && <PremiumAccessButton isPaid={isVoucherCheckPassed} page="detail" communityUserId={roomData.owner.community_user_id} />;
    $[0] = isClient;
    $[1] = isMobile;
    $[2] = isMobileApp;
    $[3] = isVoucherCheckPassed;
    $[4] = roomData;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
export type RoomAlertVariant = 'preferredDevice' | 'premium' | 'platformCompatibility';
type AlertConfig = {
  icon?: ReactNode;
  message: ReactNode;
  children?: () => ReactNode;
};
const getRoomAlertConfig = (variant: RoomAlertVariant, t: ReturnType<typeof useTranslations>, isIosMobileApp: boolean): AlertConfig => {
  switch (variant) {
    case 'preferredDevice':
      return {
        icon: <WarningIcon />,
        message: t.rich('trailer-carousel.device-alert-overlay-description', {
          alertTitle: t('trailer-carousel.device-alert-title'),
          title: (chunks: ReactNode) => <span className="subheader4-omni-styles">{chunks}</span>
        })
      };
    case 'premium':
      if (isIosMobileApp) {
        return {
          icon: <WarningIcon />,
          message: t.rich('trailer-carousel.ios-app-premium-alert-overlay-description', {
            alertTitle: t('trailer-carousel.ios-app-premium-alert-title'),
            title: (chunks: ReactNode) => <span className="subheader4-omni-styles">{chunks}</span>
          })
        };
      }
      return {
        icon: <IconDiamond className="fill-[#FF82FB]" />,
        message: t.rich('trailer-carousel.premium-alert-overlay-description', {
          alertTitle: t('trailer-carousel.premium-alert-title'),
          title: (chunks: ReactNode) => <span className="subheader4-omni-styles bg-gradient-title-3 bg-clip-text text-transparent">
              {chunks}
            </span>
        }),
        children: () => <RenderPremiumButton />
      };
    case 'platformCompatibility':
      return {
        message: t('trailer-carousel.platform-compatibility-alert-overlay-description')
      };
  }
};
type RoomAlertOverlayProps = {
  onClose: () => void;
  variant: RoomAlertVariant;
  className?: string;
};
const RoomAlertOverlay = t0 => {
  const $ = _c(21);
  const {
    onClose,
    variant,
    className
  } = t0;
  const {
    isMobileLandscape,
    isIosMobileApp
  } = useUAContext();
  const t = useTranslations();
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== className || $[1] !== isIosMobileApp || $[2] !== isMobileLandscape || $[3] !== t || $[4] !== variant) {
    const {
      icon,
      message,
      children
    } = getRoomAlertConfig(variant, t, isIosMobileApp);
    const t5 = isMobileLandscape ? "mx-0 mt-0 mb-0 w-full rounded-none" : "mx-0 mt-0 mb-0 w-full rounded-none md:mx-4 md:my-4 md:w-[calc(100%-32px)] md:rounded-[7px] md:p-2 md:px-4";
    if ($[9] !== className || $[10] !== t5) {
      t1 = cn("z-interactive absolute right-0 left-0 flex items-center gap-3 bg-[#131b26]/30 px-3 py-1.5 backdrop-blur-[50px]", t5, className);
      $[9] = className;
      $[10] = t5;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    t2 = icon && <div className={cn("shrink-0", isMobileLandscape ? "h-4 w-4" : "h-4 w-4 md:h-5 md:w-5")}>{icon}</div>;
    t3 = <p className="body2-omni-styles flex-1 wrap-break-word text-white">{message}</p>;
    t4 = children?.();
    $[0] = className;
    $[1] = isIosMobileApp;
    $[2] = isMobileLandscape;
    $[3] = t;
    $[4] = variant;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CloseIcon className="h-full w-full" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onClose) {
    t6 = <Button onClick={onClose} size="custom" className="active:[&>svg>path]:fill-vive-primary-30 z-interactive h-5 w-5 shrink-0 bg-transparent p-0 max-md:h-4 max-md:w-4 hover:[&>svg>path]:fill-white">{t5}</Button>;
    $[13] = onClose;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t6) {
    t7 = <div className={t1}>{t2}{t3}{t4}{t6}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default RoomAlertOverlay;